var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dialog', {
    staticClass: "web-cam-dialog",
    attrs: {
      "open": ""
    }
  }, [_c('div', {
    staticClass: "web-cam-title"
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))]), _c('button', {
    staticClass: "s-close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click() {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v("✕")])]), _c('div', {
    staticClass: "web-cam-container"
  }, [_c('video', {
    ref: "webCam",
    staticClass: "wev-cam-video",
    attrs: {
      "autoplay": "",
      "playsinline": ""
    }
  }), _vm.maskImage ? _c('img', {
    staticClass: "mask-overlay",
    attrs: {
      "src": _vm.maskImage
    }
  }) : _vm._e()]), _c('canvas', {
    ref: "canvas",
    staticClass: "d-none"
  }), _c('div', {
    staticClass: "web-cam-actions"
  }, [_c('SharedButton', {
    staticClass: "s-btn s-btn-bg-primary s-btn-xs",
    on: {
      "click": function click() {
        return _vm.snap();
      }
    }
  }, [_vm._v("拍照")]), _c('SharedButton', {
    staticClass: "s-btn s-btn-bg-primary s-btn-xs",
    on: {
      "click": function click() {
        return _vm.flip();
      }
    }
  }, [_vm._v("反轉鏡頭")])], 1), _vm.showReminder ? _c('dialog', {
    staticClass: "reminder-dialog",
    attrs: {
      "open": ""
    }
  }, [_c('div', {
    staticClass: "reminder-dialog-content m-4"
  }, [_c('h2', [_vm._v(_vm._s(_vm.reminder.title))]), _c('p', [_vm._v(_vm._s(_vm.reminder.text))]), _c('div', {
    staticClass: "mx-auto"
  }, [_c('SharedButton', {
    staticClass: "s-btn s-btn-bg-primary s-btn-xs mx-auto",
    attrs: {
      "variant": ""
    },
    on: {
      "click": function click() {
        return _vm.showReminder = false;
      }
    }
  }, [_vm._v(" 確定 ")])], 1)])]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }